import _str from "shared/util/_str";

export const EXISTING_PAYMENT_SCREEN = "payments.EXISTING_PAYMENT_SCREEN";
export const CREDIT_SCREEN = "payments.CREDIT_SCREEN";
export const PAYPAL_SCREEN = "payments.PAYPAL_SCREEN";
export const PAYMENT_CONFIRMATION_SCREEN = "payments.PAYMENT_CONFIRMATION_SCREEN";
export const PRODUCT_PACKAGES_SCREEN = "payments.PRODUCT_PACKAGES_SCREEN";

export const CREDIT_CARD_PAYMENT = "payments.CREDIT_CARD_PAYMENT";
export const PAYPAL_PAYMENT = "payments.PAYPAL_PAYMENT";

export const PACKAGES_FORM_NAMES = {
	boostPackage: "PACKAGES_FORM_NAMES.boost-package",
};

// make this equal to themselves so they can be piped into other shit
export const CREDIT_FORM_NAMES = {
	cardholderName: "cardholderName",
	cardNumber: "cardNumber",
	cvv: "cvv",
	expiration: "expiration",
	zipCode: "zipCode",
	creditPurchaseScreen: "creditPurchaseScreen",
	paypalPurchaseScreen: "paypalPurchaseScreen",
};

export const CREDIT_FORM_AUTOCOMPLETE = {
	[CREDIT_FORM_NAMES.cardholderName]: "cc-name",
	[CREDIT_FORM_NAMES.cardNumber]: "cc-number",
	[CREDIT_FORM_NAMES.cvv]: "cc-cvv",
	[CREDIT_FORM_NAMES.expiration]: "cc-exp",
	[CREDIT_FORM_NAMES.zipCode]: "postal-code",
};

export const CREDIT_FORM_NAME_TO_PARAM_MAP = {
	[CREDIT_FORM_NAMES.cardholderName]: "holder_name",
	[CREDIT_FORM_NAMES.cardNumber]: "card_number",
	[CREDIT_FORM_NAMES.cvv]: "cvv",
	[CREDIT_FORM_NAMES.expiration]: "exp_date",
	[CREDIT_FORM_NAMES.zipCode]: "zipcode",
};

export const CREDIT_FORM_HUMAN_NAMES = {
	[CREDIT_FORM_NAMES.cardholderName]: _str("Cardholder Name"),
	[CREDIT_FORM_NAMES.cardNumber]: _str("Card Number"),
	[CREDIT_FORM_NAMES.cvv]: _str("CVV"),
	[CREDIT_FORM_NAMES.expiration]: _str("Expiration"),
	[CREDIT_FORM_NAMES.zipCode]: _str("Zip Code"),
};

export const ERRORS = {
	emptyField: "STATUS_MESSAGES.emptyField",
	malformedCvv: "STATUS_MESSAGES.malformedCvv",
	malformedCardNumber: "STATUS_MESSAGES.malformedCardNumber",
	malformedExpiration: "STATUS_MESSAGES.malformedExpiration",
};

export const ERROR_MESSAGES = {
	[ERRORS.emptyField]: _str("This is required!"),
	[ERRORS.malformedZip]: _str("This looks wrong!"),
	[ERRORS.malformedCvv]: _str("CVVs are 3-4 numbers."),
	[ERRORS.malformedCardNumber]: _str("A card is 12 to 19 numbers."),
	[ERRORS.malformedExpiration]: _str("Dates must be MM / YY."),
};

export const AMERICAN_EXPRESS = "american-express";
export const VISA = "visa";
export const MASTER_CARD = "master-card";
export const DISCOVER = "discover";

export const CREDIT_CARD_PAYMENT_PROCESSOR = "USAEPAY";
export const PAYPAL_PAYMENT_PROCESSOR = "PAYPAL";

export const PLATFORMS = {
	DESKTOP: "DESKTOP",
	MOBILE_WEB: "MOBILE_WEB",
	ANDROID: "ANDROID_WEB",
	IOS: "IOS",
};

export const TAX_TYPES = {
	SALES: "SALES",
	VAT: "VAT",
};

export const PRODUCT_TYPES = {
	TOKEN: "TOKEN",
	SUBSCRIPTION: "SUBSCRIPTION",
	OTP: "OTP",
};

export const PRODUCT_SUBTYPES = {
	ALIST: "ALIST",
	ALISTPREMIUM: "ALISTPREMIUM",
	INCOGNITO: "INCOGNITO",
	BOOST: "BOOST",
	MAILBOXBRIBE: "MAILBOXBRIBE",
	BIGMAILBOX: "BIGMAILBOX",
	NOADS: "NOADS",
	SPOTLIGHT: "SPOTLIGHT",
	READ_RECEIPT: "READ_RECEIPT",
	STACK_PASS: "STACK_PASS",
};

export const PRODUCT_SUBTYPE_NAMES = {
	ALIST: "A-List Basic",
	ALISTPREMIUM: "A-List Premium",
	INCOGNITO: "Incognito",
	BOOST: "Boost",
	MAILBOXBRIBE: "Mailbox Bribe",
	BIGMAILBOX: "Big Mailbox",
	NOADS: "No Ads",
	STACK_PASS: "Stack Pass",
};

export const QUERY_PARAM_PAYMENT_TYPE = {
	paypal: "paypal",
	credit_card: "credit_card",
};

export const PAYMENT_TYPES_TO_SCREEN = {
	[QUERY_PARAM_PAYMENT_TYPE.paypal]: PAYPAL_SCREEN,
	[QUERY_PARAM_PAYMENT_TYPE.credit_card]: CREDIT_SCREEN,
};

export const PRODUCT_DETAILS = {
	ID: "productid",
	SUB_PERIOD: "subPeriod",
	TOKENS_NUM: "tokensNumber",
};

export const PRODUCT_TYPE_MAP = {
	[PRODUCT_SUBTYPES.ALIST]: PRODUCT_TYPES.SUBSCRIPTION,
	[PRODUCT_SUBTYPES.ALISTPREMIUM]: PRODUCT_TYPES.SUBSCRIPTION,
	[PRODUCT_SUBTYPES.INCOGNITO]: PRODUCT_TYPES.SUBSCRIPTION,
	[PRODUCT_SUBTYPES.BOOST]: PRODUCT_TYPES.TOKEN,
	[PRODUCT_SUBTYPES.SPOTLIGHT]: PRODUCT_TYPES.TOKEN,
	[PRODUCT_SUBTYPES.MAILBOXBRIBE]: PRODUCT_TYPES.TOKEN,
	[PRODUCT_SUBTYPES.BIGMAILBOX]: PRODUCT_TYPES.OTP,
	[PRODUCT_SUBTYPES.NOADS]: PRODUCT_TYPES.OTP,
	[PRODUCT_SUBTYPES.READ_RECEIPT]: PRODUCT_TYPES.TOKEN,
	[PRODUCT_SUBTYPES.STACK_PASS]: PRODUCT_TYPES.TOKEN,
};

export const SUBTYPE_TO_TOKEN_TYPE_MAP = {
	[PRODUCT_SUBTYPES.BOOST]: "spotlight",
	[PRODUCT_SUBTYPES.READ_RECEIPT]: "read_receipt",
};

export const SUBTYPE_TO_FEATURE_MAP = {
	[PRODUCT_SUBTYPES.ALIST]: "alist",
	[PRODUCT_SUBTYPES.ALISTPREMIUM]: "alist",
	[PRODUCT_SUBTYPES.BOOST]: null,
	[PRODUCT_SUBTYPES.INCOGNITO]: "incognito",
	[PRODUCT_SUBTYPES.READ_RECEIPT]: null,
};

export const SAVE_PAYPAL_INFO_PRODUCT_ID = "com.okcupid.billagreement.1.00.245";

export const DEFAULT_ALIST_PACKAGE_DURATION_MOBILE = 3;



// WEBPACK FOOTER //
// ./src/shared/payment/constants.js